import React, { useCallback, useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import GuestNumber from "../WebAppBar/GuestNumber";
import SearchIcon from "@material-ui/icons/Search";
import IconButton from "@material-ui/core/IconButton";
import { Box, Typography } from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InforWindow,
  InfoWindow,
  InfoBox,
} from "@react-google-maps/api";
import {
  Combobox,
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption,
} from "@reach/combobox";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import { useAutocomplete } from "@material-ui/lab";
import { useDispatch } from "react-redux";
import {
  addAddressLatLng,
  addChosenPlace,
  addCityName,
  addLatLng,
} from "../../Actions/RoomDataAction";
import { DatePicker } from "@material-ui/pickers";
import { blankLatLng } from "../../Actions/BlankLatLngAction";
import { useHistory } from "react-router-dom";
import { addCheckDate } from "../../Actions/CheckDateAction";
import { useSelector } from "react-redux";

export default function InputInfor(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      backgroundColor: "#f4f4f4",
      padding: "0 0.5%",
      borderRadius: 50,
      border: "1px solid #cfd3ce ",
      "&:hover": {
        boxShadow: "0px 5px 20px 0px #000000c2",
      },
    },
    Paper: {
      backgroundColor: "white",
    },
    SearchIcon: {
      padding: "5px 2px",
    },
    datePicker: {
      "&:hover": { borderWidth: 0 },
    },
    comboBox: {
      padding: "0 0 0 10px",
      width: "100%",
      backgroundColor: "transparent",
      padding: "0 20px",
    },
    comboBoxInput: {
      "&:focus": { outline: "none" },
      border: "none",
      width: "100%",
      fontSize: "15px",
      backgroundColor: "transparent",
    },
    comboBoxPopover: {
      backgroundColor: "white",
      zIndex: 100,
      padding: "10px",
    },
    timKiem: {
      fontSize: 20,
      [theme.breakpoints.down("xs")]: {
        display: "none",
      },
    },
  }));
  const classes = useStyles();
  const dispatch = useDispatch();
  let history = useHistory();
  const [search, setSearch] = useState(false);
  const [addressLatLng, setAddressLatLng] = useState(null);
  const inputRef = useRef();
  // comboBox suggest
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      location: { lat: () => 10.78407, lng: () => 106.669956 },
      radius: 100 * 1000,
    },
  });

  // set cheking dates
  const checkDate = useSelector((state) => state.checkDate);
  const [checkInDate, setCheckInDate] = useState(checkDate.checkInDate);
  const [checkOutDate, setCheckOutDate] = useState(checkDate.checkOutDate);
  function handleCheckInDate(checkInDate) {
    const dateCheck = { checkInDate, checkOutDate };

    setCheckInDate(checkInDate);
    dispatch(addCheckDate(dateCheck));
  }

  function handleCheckOutDate(checkOutDate) {
    const dateCheck = { checkInDate, checkOutDate };

    setCheckOutDate(checkOutDate);
    dispatch(addCheckDate(dateCheck));
  }
  const chosenPlace = useSelector((state) => state.roomData.chosenPlace);
  const libraries = ["places"];
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });
  if (loadError) return "Error loading maps";
  if (!isLoaded) return "Loading Maps";
  async function onSelect(address) {
    setValue(address, false);
    clearSuggestions();
    try {
      const results = await getGeocode({ address });
      const { lat, lng } = await getLatLng(results[0]);

      const value = [address, { lat, lng }];
      setAddressLatLng(value);
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <div ref={inputRef} style={{ padding: "0 15%" }}>
      <Grid container className={classes.root} xs={12} alignItems="center">
        <Grid container justify="center" item xs={10} lg={5}>
          <Combobox
            className={classes.comboBox}
            onSelect={(address) => {
              onSelect(address);
            }}
          >
            <ComboboxInput
              className={classes.comboBoxInput}
              value={value}
              onChange={(e) => {
                setValue(e.target.value);
              }}
              placeholder="Bạn muốn đến đâu?"
            ></ComboboxInput>
            <ComboboxPopover className={classes.comboBoxPopover}>
              {status === "OK" &&
                data.map(({ description, id }) => (
                  <ComboboxOption key={id} value={description} />
                ))}
            </ComboboxPopover>
          </Combobox>
        </Grid>
        <Hidden mdDown>
          <Grid justify="center" container item lg={2}>
            <Grid item xs={1} container alignItems="center">
              <div
                style={{ borderLeft: "1px solid #c4b6b6", height: "30px" }}
              />
            </Grid>
            <Grid item container xs={11} onClick={props.setAddPadding}>
              <DatePicker
                disablePast="true"
                disableToolbar
                variant="inline"
                label="Ngày đi"
                value={checkDate.checkInDate}
                onChange={handleCheckInDate}
                PopoverProps={{ container: () => inputRef.current }}
                InputProps={{
                  disableUnderline: true,
                }}
              />
            </Grid>
          </Grid>
          <Grid justify="center" container item lg={2}>
            <Grid item xs={1} container alignItems="center">
              <div
                style={{ borderLeft: "1px solid #c4b6b6", height: "30px" }}
              />
            </Grid>
            <Grid item container xs={11}>
              <DatePicker
                disablePast="true"
                disableToolbar
                variant="inline"
                label="Ngày về"
                PopoverProps={{ container: () => inputRef.current }}
                value={checkDate.checkOutDate}
                onChange={handleCheckOutDate}
                InputProps={{
                  disableUnderline: true,
                }}
              />
            </Grid>
          </Grid>
          <Grid lg={2} item container>
            <Grid item xs={1} container alignItems="center">
              <div
                style={{ borderLeft: "1px solid #c4b6b6", height: "30px" }}
              />
            </Grid>
            <Grid item container xs={11}>
              <GuestNumber />
            </Grid>
          </Grid>
        </Hidden>
        <Grid
          xs={2}
          lg={1}
          container
          item
          className={classes.SearchIcon}
          justify="flex-end"
        >
          <IconButton
            item
            style={{
              borderRadius: 50,
              color: "white",
              backgroundColor: "#fd3a69",
            }}
            onClick={() => {
              if (addressLatLng) {
                history.push("/place");
                dispatch(addAddressLatLng(addressLatLng));
              }
            }}
          >
            <SearchIcon />

            <Typography className={classes.timKiem}>
              Tìm kiếm
            </Typography>
          </IconButton>
        </Grid>
      </Grid>
    </div>
  );
}
